// import React, {FC} from 'react'
// import {Link} from 'react-router-dom'
// import {KTIcon} from '../../../helpers'
// import {Item1} from '../../content/activity/Item1'
// import {Item2} from '../../content/activity/Item2'
// import {Item3} from '../../content/activity/Item3'
// import {Item4} from '../../content/activity/Item4'
// import {Item5} from '../../content/activity/Item5'
// import {Item6} from '../../content/activity/Item6'
// import {Item7} from '../../content/activity/Item7'
// import {Item8} from '../../content/activity/Item8'

// const ActivityDrawer: FC = () => (
//   <div
//     id='kt_activities'
//     className='bg-body'
//     data-kt-drawer='true'
//     data-kt-drawer-name='activities'
//     data-kt-drawer-activate='true'
//     data-kt-drawer-overlay='true'
//     data-kt-drawer-width="{default:'300px', 'lg': '900px'}"
//     data-kt-drawer-direction='end'
//     data-kt-drawer-toggle='#kt_activities_toggle'
//     data-kt-drawer-close='#kt_activities_close'
//   >
//     <div className='card shadow-none rounded-0'>
//       <div className='card-header' id='kt_activities_header'>
//         <h3 className='card-title fw-bolder text-dark'>Activity Logs</h3>

//         <div className='card-toolbar'>
//           <button
//             type='button'
//             className='btn btn-sm btn-icon btn-active-light-primary me-n5'
//             id='kt_activities_close'
//           >
//             <KTIcon iconName='cross' className='fs-1' />
//           </button>
//         </div>
//       </div>
//       <div className='card-body position-relative' id='kt_activities_body'>
//         <div
//           id='kt_activities_scroll'
//           className='position-relative scroll-y me-n5 pe-5'
//           data-kt-scroll='true'
//           data-kt-scroll-height='auto'
//           data-kt-scroll-wrappers='#kt_activities_body'
//           data-kt-scroll-dependencies='#kt_activities_header, #kt_activities_footer'
//           data-kt-scroll-offset='5px'
//         >
//           <div className='timeline'>
//             <Item1 />
//             <Item2 />
//             <Item3 />
//             <Item4 />
//             <Item5 />
//             <Item6 />
//             <Item7 />
//             <Item8 />
//           </div>
//         </div>
//       </div>
//       <div className='card-footer py-5 text-center' id='kt_activities_footer'>
//         <Link to='/crafted/pages/profile' className='btn btn-bg-body text-primary'>
//           View All Activities
//           <KTIcon iconName='arrow-right' className='fs-3 text-primary' />
//         </Link>
//       </div>
//     </div>
//   </div>
// )

// export {ActivityDrawer}
















// import React, { FC } from 'react'
// import { Link } from 'react-router-dom'
// import { KTIcon } from '../../../helpers'
// import { Item1 } from '../../content/activity/Item1'
// import { Item2 } from '../../content/activity/Item2'
// import { Item3 } from '../../content/activity/Item3'
// import { Item4 } from '../../content/activity/Item4'
// import { Item5 } from '../../content/activity/Item5'
// import { Item6 } from '../../content/activity/Item6'
// import { Item7 } from '../../content/activity/Item7'
// import { Item8 } from '../../content/activity/Item8'
// import { useState, useEffect } from 'react'
// import { useAuth } from '../../../../app/modules/auth'

// const ActivityDrawer: FC = () => {
//   const [logsData, setLogsData] = useState(null)
//   const [loading, setLoading] = useState(true)

//   // useEffect(() => {
//   //   const fetchLogs = async () => {
//   //     try {
//   //       // Get token from localStorage
//   //       const authData = localStorage.getItem('kt-auth-react-v')
//   //       const token = authData ? JSON.parse(authData).data.token : null
//   //       const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}logs`, {
//   //         headers: {
//   //           'Authorization': `Bearer ${token}`,
//   //           'Content-Type': 'application/json'
//   //         }
//   //       })
//   //       const result = await response.json()
//   //       setLogsData(result)
//   //       setLoading(false)
//   //     } catch (error) {
//   //       console.error('Error fetching logs:', error)
//   //       setLoading(false)
//   //     }
//   //   }
//   //   fetchLogs()
//   // }, [])




//   const { currentUser } = useAuth()

//   useEffect(() => {
//     const fetchLogs = async () => {
//       try {
//         // Get token from localStorage
//         const authData = localStorage.getItem('kt-auth-react-v')
//         const parsedAuth = authData ? JSON.parse(authData).data : null
//         const token = parsedAuth?.token || null

//         // Build headers
//         const headers: Record<string, string> = {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         }

//         // Add headers based on userType
//         if ((currentUser as any)?.userType === 'PICKUP_POINT_STAFF') {
//           headers['franchiseeid'] = parsedAuth?.franchiseeid || ''
//           headers['pickuppointid'] = parsedAuth?.pickuppointid || ''
//         } else if ((currentUser as any)?.userType === 'FRANCHISE_USER') {
//           headers['franchiseId'] = parsedAuth?.franchiseId || ''
//         }

//         console.log('Headers being sent:', headers)

//         const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}logs`, {
//           headers: headers
//         })
//         const result = await response.json()
//         console.log('API Response:', result)
//         setLogsData(result)
//         setLoading(false)
//       } catch (error) {
//         console.error('Error fetching logs:', error)
//         setLoading(false)
//       }
//     }
//     fetchLogs()
//   }, [])

//   return (
//     <div
//       id='kt_activities'
//       className='bg-body'
//       data-kt-drawer='true'
//       data-kt-drawer-name='activities'
//       data-kt-drawer-activate='true'
//       data-kt-drawer-overlay='true'
//       data-kt-drawer-width="{default:'300px', 'lg': '900px'}"
//       data-kt-drawer-direction='end'
//       data-kt-drawer-toggle='#kt_activities_toggle'
//       data-kt-drawer-close='#kt_activities_close'
//     >
//       <div className='card shadow-none rounded-0'>
//         <div className='card-header' id='kt_activities_header'>
//           <h3 className='card-title fw-bolder text-dark'>Activity Logs</h3>
//           <div className='card-toolbar'>
//             <button
//               type='button'
//               className='btn btn-sm btn-icon btn-active-light-primary me-n5'
//               id='kt_activities_close'
//             >
//               <KTIcon iconName='cross' className='fs-1' />
//             </button>
//           </div>
//         </div>
//         <div className='card-body position-relative' id='kt_activities_body'>
//           <div
//             id='kt_activities_scroll'
//             className='position-relative scroll-y me-n5 pe-5'
//             data-kt-scroll='true'
//             data-kt-scroll-height='auto'
//             data-kt-scroll-wrappers='#kt_activities_body'
//             data-kt-scroll-dependencies='#kt_activities_header, #kt_activities_footer'
//             data-kt-scroll-offset='5px'
//           >
//             <div className='timeline'>
//               <Item1 data={logsData} loading={loading} />
//               {/* <Item2 />
//               <Item3 />
//               <Item4 />
//               <Item5 />
//               <Item6 />
//               <Item7 />
//               <Item8 /> */}
//             </div>
//           </div>
//         </div>
//         <div className='card-footer py-5 text-center' id='kt_activities_footer'>
//           <Link to='/apps/transactions' className='btn btn-bg-body text-primary' style={{ color:"#1b84ff"}}>
//             View All Activities
//             <KTIcon iconName='arrow-right' className='fs-3 text-primary' />
//           </Link>
//         </div>
//       </div>
//     </div>
//   )
// }

// export { ActivityDrawer }







import React, { FC, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { KTIcon } from '../../../helpers'
import { Item1 } from '../../content/activity/Item1'
import { useAuth } from '../../../../app/modules/auth'

const ActivityDrawer: FC = () => {
  const [logsData, setLogsData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const { currentUser } = useAuth()

  // Detect when drawer is opened
  useEffect(() => {
    const drawerElement = document.getElementById('kt_activities')

    if (!drawerElement) return

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          const isOpen = drawerElement.classList.contains('drawer-on')
          setIsDrawerOpen(isOpen)
        }
      })
    })

    observer.observe(drawerElement, {
      attributes: true,
      attributeFilter: ['class']
    })

    return () => observer.disconnect()
  }, [])

  // Only fetch logs when drawer is opened
  useEffect(() => {
    if (!isDrawerOpen || logsData) return // Don't fetch if already have data

    const fetchLogs = async () => {
      setLoading(true)
      try {
        // Get token from localStorage
        const authData = localStorage.getItem('kt-auth-react-v')
        const parsedAuth = authData ? JSON.parse(authData).data : null
        const token = parsedAuth?.token || null

        // Build headers
        const headers: Record<string, string> = {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }

        // Add headers based on userType
        if ((currentUser as any)?.userType === 'PICKUP_POINT_STAFF') {
          headers['franchiseeid'] = parsedAuth?.franchiseeid || ''
          headers['pickuppointid'] = parsedAuth?.pickuppointid || ''
        } else if ((currentUser as any)?.userType === 'FRANCHISE_USER') {
          headers['franchiseId'] = parsedAuth?.franchiseId || ''
        }

        // Add pagination to limit data - fetch only last 50 logs
        const response = await fetch(
          `${process.env.REACT_APP_BASE_API_URL}logs`,
          { headers: headers }
        )

        if (!response.ok) {
          throw new Error('Failed to fetch logs')
        }

        const result = await response.json()
        setLogsData(result)
      } catch (error) {
        console.error('Error fetching logs:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchLogs()
  }, [isDrawerOpen, currentUser, logsData])

  return (
    <div
      id='kt_activities'
      className='bg-body'
      data-kt-drawer='true'
      data-kt-drawer-name='activities'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'300px', 'lg': '900px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_activities_toggle'
      data-kt-drawer-close='#kt_activities_close'
    >
      <div className='card shadow-none rounded-0'>
        <div className='card-header' id='kt_activities_header'>
          <h3 className='card-title fw-bolder text-dark'>Activity Logs</h3>
          <div className='card-toolbar'>
            <button
              type='button'
              className='btn btn-sm btn-icon btn-active-light-primary me-n5'
              id='kt_activities_close'
            >
              <KTIcon iconName='cross' className='fs-1' />
            </button>
          </div>
        </div>
        <div className='card-body position-relative' id='kt_activities_body'>
          <div
            id='kt_activities_scroll'
            className='position-relative scroll-y me-n5 pe-5'
            data-kt-scroll='true'
            data-kt-scroll-height='auto'
            data-kt-scroll-wrappers='#kt_activities_body'
            data-kt-scroll-dependencies='#kt_activities_header, #kt_activities_footer'
            data-kt-scroll-offset='5px'
          >
            {loading ? (
              <div className='text-center py-10'>
                <span className='spinner-border spinner-border-lg align-middle ms-2'></span>
                <p className='mt-3 text-gray-600'>Loading activity logs...</p>
              </div>
            ) : (
              <div className='timeline'>
                <Item1 data={logsData} loading={loading} />
              </div>
            )}
          </div>
        </div>
        <div className='card-footer py-5 text-center' id='kt_activities_footer'>
          <Link to='/apps/transactions' className='btn btn-bg-body text-primary' style={{ color: "#1b84ff" }}>
            View All Activities
            <KTIcon iconName='arrow-right' className='fs-3 text-primary' />
          </Link>
        </div>
      </div>
    </div>
  )
}

export { ActivityDrawer }









// import React, { FC } from 'react'
// import { Link } from 'react-router-dom'
// import { KTIcon } from '../../../helpers'
// import { Item1 } from '../../content/activity/Item1'
// import { Item2 } from '../../content/activity/Item2'
// import { Item3 } from '../../content/activity/Item3'
// import { Item4 } from '../../content/activity/Item4'
// import { Item5 } from '../../content/activity/Item5'
// import { Item6 } from '../../content/activity/Item6'
// import { Item7 } from '../../content/activity/Item7'
// import { Item8 } from '../../content/activity/Item8'

// const ActivityDrawer: FC = () => {
//   return (
//     <div
//       id='kt_activities'
//       className='bg-body'
//       data-kt-drawer='true'
//       data-kt-drawer-name='activities'
//       data-kt-drawer-activate='true'
//       data-kt-drawer-overlay='true'
//       data-kt-drawer-width="{default:'300px', 'lg': '900px'}"
//       data-kt-drawer-direction='end'
//       data-kt-drawer-toggle='#kt_activities_toggle'
//       data-kt-drawer-close='#kt_activities_close'
//     >
//       <div className='card shadow-none rounded-0'>
//         <div className='card-header' id='kt_activities_header'>
//           <h3 className='card-title fw-bolder text-dark'>Activity Logs</h3>
//           <div className='card-toolbar'>
//             <button
//               type='button'
//               className='btn btn-sm btn-icon btn-active-light-primary me-n5'
//               id='kt_activities_close'
//             >
//               <KTIcon iconName='cross' className='fs-1' />
//             </button>
//           </div>
//         </div>
//         <div className='card-body position-relative' id='kt_activities_body'>
//           <div
//             id='kt_activities_scroll'
//             className='position-relative scroll-y me-n5 pe-5'
//             data-kt-scroll='true'
//             data-kt-scroll-height='auto'
//             data-kt-scroll-wrappers='#kt_activities_body'
//             data-kt-scroll-dependencies='#kt_activities_header, #kt_activities_footer'
//             data-kt-scroll-offset='5px'
//           >
//             <div className='timeline'>
//               <Item1 />
//               <Item2 />
//               <Item3 />
//               <Item4 />
//               <Item5 />
//               <Item6 />
//               <Item7 />
//               <Item8 />
//             </div>
//           </div>
//         </div>
//         <div className='card-footer py-5 text-center' id='kt_activities_footer'>
//           <Link to='/crafted/pages/profile' className='btn btn-bg-body text-primary'>
//             View All Activities
//             <KTIcon iconName='arrow-right' className='fs-3 text-primary' />
//           </Link>
//         </div>
//       </div>
//     </div>
//   )
// }

// export { ActivityDrawer }